const reportCenter = {
    label: '报表中心',
    title: '报表中心',
    description:
      '报表中心旨在自动化的检索，分析各类指标情况；并进行可视化的展示。提高洞察力，帮助您做出更好的决策。',
    createReport: '新建报表',
    browseTemplates: '查看模板库',
    highlightSearch: '自动化检索',
    highlightMetrics: '指标分析',
    highlightVisual: '可视化展示',
    heroMetricTitle: '人才规模',
    heroMetricNote: '最新数据',
    heroChartLabel: '连接转化',
    heroChartSubLabel: '当前区间',
    scopeLabel: '范围',
    scopeAll: '全部人才',
    workspaceLabel: '模块',
    dashboardTab: '主页',
    templatesTab: '模板库',
    sourcesTab: '数据源',
    themeLabel: '主题',
    themeOverview: '总览',
    themeQuality: '质量',
    themeChannel: '渠道',
    refresh: '刷新数据',
    metricsTitle: '核心指标一览',
    metricsDesc: '对关键 KPI 做汇总监控，快速定位瓶颈与增长空间。',
    metricsAction: '导出指标',
    metricTotalCandidates: '人才总量',
    metricTotalNote: '人才库规模',
    metricAdded: '已添加好友',
    metricAddedNote: '连接已完成',
    metricPending: '等待验证',
    metricPendingNote: '正在处理中',
    metricOpenToWork: '开放求职',
    metricOpenToWorkNote: '可优先跟进',
    metricChipAll: '全量',
    metricChipConnect: '连接',
    metricChipPending: '待处理',
    metricChipOpen: '优先',
    overviewTitle: '招聘经营概览',
    overviewDesc: '把漏斗、标签表现、岗位推进和异常提醒集中放在一屏里。',
    funnelTitle: '招聘漏斗',
    funnelPool: '人才入库',
    funnelReachable: '已连接/可触达',
    funnelPending: '等待验证',
    funnelPriority: '重点跟进',
    topTagsTitle: '标签表现榜',
    topTagsNote: '按标签人才量排序',
    topTagsRank: '第 {rank} 名',
    jobSummaryTitle: '岗位推进摘要',
    jobSummaryNote: '观察岗位处理负载与完成度',
    alertsTitle: '风险提醒',
    alertsNote: '帮助招聘负责人快速发现异常',
    alertBacklogTitle: '待跟进候选人较多',
    alertBacklogDesc: '当前仍有 {count} 位候选人未发送请求，建议优先清理积压。',
    alertFailedTitle: '岗位分析存在失败任务',
    alertFailedDesc: '当前有 {count} 个岗位分析失败，建议排查 JD 或重试。',
    alertHealthyTitle: '当前招聘盘面稳定',
    alertHealthyDesc: '暂无明显异常，可继续按当前节奏推进。',
    chartsTitle: '报表可视化面板',
    chartsDesc: '面向 HR 的数据驾驶舱，支持 ECharts 等多种图表组件。',
    templatesTag: '内置模板',
    chartTagsTitle: '标签分布',
    chartTagsDesc: '候选人按标签的数量分布',
    chartTagsFooter: '总量',
    chartJobsTitle: '岗位处理进度',
    chartJobsDesc: '当前岗位分析状态概览',
    chartJobsFooter: '岗位总数',
    chartFriendTitle: '好友状态占比',
    chartFriendDesc: '添加好友与验证状态分布',
    chartFriendFooter: '连接率',
    chartTagDistribution: '标签分布',
    chartTagPipeline: '岗位进度',
    chartTagStatus: '状态',
    detailScope: '范围',
    detailUpdated: '更新时间',
    viewTags: '查看标签',
    viewJobs: '查看岗位',
    friendAdded: '已添加',
    friendPending: '待验证',
    friendNotSent: '未发送',
    friendActive: '活跃',
    friendOpenToWork: '开放求职',
    jobStatusPending: '待处理',
    jobStatusAnalyzing: '分析中',
    jobStatusCompleted: '已完成',
    jobStatusFailed: '失败',
    templatesTitle: '内置模板库',
    templatesDesc: '从模板快速生成招聘分析报表，并支持一键复用。',
    templateSearch: '搜索模板',
    templatePreview: '预览',
    templateFavorite: '收藏',
    templateFavorited: '已收藏',
    templateUse: '立即使用',
    templateCategoryAll: '全部模板',
    templateCategoryFunnel: '招聘漏斗',
    templateCategoryChannel: '渠道效率',
    templateCategoryPipeline: '岗位推进',
    templateCategoryReview: '管理复盘',
    templateFunnelTitle: '招聘漏斗分析',
    templateFunnelDesc: '追踪每个流程节点的转化与流失',
    templateFunnelTag: '流程',
    templateChannelTitle: '渠道效率对比',
    templateChannelDesc: '对比渠道质量、成本与转化表现',
    templateChannelTag: '渠道',
    templateQualityTitle: '候选人质量热图',
    templateQualityDesc: '能力与岗位匹配分布可视化',
    templateQualityTag: '质量',
    templatePipelineTitle: '岗位推进周期',
    templatePipelineDesc: '从投递到入职的周期分布',
    templatePipelineTag: '周期',
    templateTeamTitle: '用人部门满意度',
    templateTeamDesc: '团队反馈与人才留存情况',
    templateTeamTag: '反馈',
    templateForecastTitle: '招聘需求预测',
    templateForecastDesc: '预测高峰岗位与人才需求变化',
    templateForecastTag: '预测',
    templateForecastValue: 'Q2',
    templateKpiPrimary: '核心指标',
    templateKpiSecondary: '关键指数',
    templateSceneLabel: '适用场景',
    templateRoleLabel: '推荐角色',
    templateRoleLeader: '招聘负责人',
    templateRoleOps: '招聘运营',
    templateRoleRecruiter: '招聘顾问',
    templateRoleManager: '团队主管',
    templateRoleBoss: '管理层',
    templateFreqDaily: '日常查看',
    templateFreqWeekly: '每周复盘',
    templateFreqMonthly: '月度汇报',
    templateFunnelScene: '适合周会复盘招聘转化效率',
    templateChannelScene: '适合对比不同标签池和渠道效率',
    templateQualityScene: '适合快速筛出高质量候选人池',
    templatePipelineScene: '适合跟进岗位推进和处理时效',
    templateTeamScene: '适合面向团队负责人做阶段复盘',
    templateForecastScene: '适合管理层查看趋势和需求变化',
    dataSourceTitle: '数据源总览',
    dataSourceDesc: '明确报表的数据来自哪里，方便核对口径与数据质量。',
    sourceTalentTitle: '人才数据源',
    sourceTalentPool: '人才池规模',
    sourceTalentOpen: '开放求职',
    sourceTalentActive: '活跃人才',
    sourceTagTitle: '标签数据源',
    sourceTagCount: '标签数量',
    sourceTagCurrent: '当前范围',
    sourceTagTop: 'Top 标签',
    sourceJobTitle: '岗位数据源',
    sourceJobTotal: '岗位总数',
    sourceJobCompleted: '分析完成',
    sourceJobFailed: '分析失败',
    sourceDefinitionTitle: '数据口径说明',
    definitionTalentTitle: '人才数据',
    definitionTalentDesc: '基于当前账号下标签人才池与候选人状态字段汇总。',
    definitionTagTitle: '标签数据',
    definitionTagDesc: '按标签维度聚合人才数量，用于查看人才池表现和分布。',
    definitionJobTitle: '岗位数据',
    definitionJobDesc: '基于岗位分析状态汇总，反映岗位处理进展和异常。',
    definitionContactTitle: '联系数据',
    definitionContactDesc: '连接率和待验证状态来自已发送请求、验证状态等字段。',
    formName: '报表名称',
    formNamePlaceholder: '请输入报表名称',
    formNameRequired: '请先填写报表名称',
    formTemplate: '选择模板',
    exportHint: '选择导出格式后将生成报表文件。',
    exportSuccess: '已导出 {format} 报表',
    createSuccess: '报表创建成功',
    fetchFailed: '报表数据获取失败',
    unavailable: '暂未开放',
  }

export default reportCenter
